import React from 'react';

const Chevron = ({
  color = 'black',
  transform,
  idName = '',
  height = '14px',
  marginLeft = '16px',
  marginRight = '10px',
  ariaLabel = 'Chevron Icon',
  hide = false,
}) => {
  return (
    <svg
      version="1.1"
      id={`${idName}-dropdown`}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      style={{ marginLeft, marginRight, transform: transform || null }}
      fill={color}
      aria-label={ariaLabel}
      aria-hidden={hide}
      height={height}
      role="img"
    >
      <g>
        <polygon points="283.6,1000 216.4,932.8 649.1,500 216.4,67.3 283.6,0 783.6,500 	" />
      </g>
    </svg>
  );
};

export default Chevron;
